"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
exports.Constants = {
    monitor: {
        defaultInterval: 200,
        defaultLineCount: 3,
    },
};
